<template>
  <div class="primary-main bank-main" v-loading="loading">
    <el-card class="box-card" style="width: 600px; margin: 20px;">
      <div slot="header" class="clearfix">
        <span>分享页配置</span>
      </div>
      <el-form label-width="120px">
        <el-form-item label="分享机构名：">
          <el-input v-model="shareForm.shareJgm" show-word-limit maxlength="15" clearable placeholder="请输入分享机构名"></el-input>
        </el-form-item>
        <el-form-item label="宣传信息：">
<!--          <el-input type="textarea" :rows="3" v-model="shareForm.shareXcxx" clearable show-word-limit maxlength="100" placeholder="请输入宣传信息"></el-input>-->
          <el-input v-model="shareForm.shareXcxx" clearable show-word-limit maxlength="15" placeholder="请输入宣传信息"></el-input>
        </el-form-item>
        <el-form-item label="二维码图片：">
          <div v-for="(item, index) in shareForm.shareQrcodeList" :key="index" style="display:flex; align-items:center; margin-bottom:10px;">
            <div style="text-align: center;">
              <el-upload
                class="avatar-uploader"
                action="api/common/uploadFile"
                :data="uploadData"
                :show-file-list="false"
                :on-success="(res) => handleQrcodeSuccess(res, index)"
                :before-upload="beforeAvatarUpload">
                <img v-if="item.qrcodeUrl" :src="getFullUrl(item.qrcodeUrl)" class="avatar" style="width:100px; height:100px; display:block;">
                <i v-else class="el-icon-plus avatar-uploader-icon" style="width:100px; height:100px; line-height:100px; text-align:center; border:1px dashed #d9d9d9;"></i>
              </el-upload>
              <el-input v-model="item.qrcodeName" show-word-limit maxlength="6" placeholder="二维码名称" clearable size="small" style="width: 200px; margin-top: 5px;"></el-input>
            </div>
            <el-button type="danger" icon="el-icon-delete" circle style="margin-left: 10px;" @click="removeQrcode(index)"></el-button>
          </div>
          <el-button type="primary" plain size="small" @click="addQrcode" v-if="shareForm.shareQrcodeList.length < 2">添加二维码(最多2个)</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveShareConfig">保存配置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      jgglId: sessionStorage.getItem("jgglId"),
      loading: false,
      userInfo: {},
      shareForm: {
        id: '',
        shareJgm: '',
        shareXcxx: '',
        shareQrcodeList: []
      },
      uploadData: {
        'access_token': sessionStorage.getItem("access_token"),
        'moduleName': 'share_qrcode'
      },
    };
  },
  created() {
    if (this.jgglId) {
      this.shareForm.id = this.jgglId;
      this.getShareConfig();
    } else {
      this.$message.error('未获取到您的机构信息');
    }
  },
  methods: {
    getFullUrl(url) {
      if (!url) return '';
      if (url.indexOf('http') === 0) return url;
      if (url.indexOf('/') === 0) {
        url = url.substring(1);
      }
      // Append access_token if needed, assuming url is like /api/sys/download...
      if (url.indexOf('?') > -1) {
        return url + '&access_token=' + sessionStorage.getItem("access_token");
      } else {
        return url + '?access_token=' + sessionStorage.getItem("access_token");
      }
    },
    getShareConfig() {
      this.loading = true;
      this.$post("xueyuan/XueyuanController/jgglShareInfoView", { id: this.shareForm.id }).then(rep => {
        this.loading = false;
        if (rep.code == 1 && rep.result.view) {
          this.shareForm.shareJgm = rep.result.view.shareJgm;
          this.shareForm.shareXcxx = rep.result.view.shareXcxx;
          this.shareForm.shareQrcodeList = rep.result.view.shareQrcodeList || [];
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    saveShareConfig() {
      if (!this.shareForm.id) {
        this.$message.error('机构信息异常，无法保存');
        return;
      }
      this.loading = true;
      this.$post("xueyuan/XueyuanController/jgglShareInfoSave", this.shareForm, "json").then(rep => {
        this.loading = false;
        if (rep.code == 1) {
          this.$message({ type: "success", message: "配置保存成功" });
        } else {
          this.$message({ type: "error", message: rep.msg });
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    addQrcode() {
      if (this.shareForm.shareQrcodeList.length < 2) {
        this.shareForm.shareQrcodeList.push({ qrcodeUrl: '', qrcodeName: '' });
      }
    },
    removeQrcode(index) {
      this.$confirm('是否确认删除', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.shareForm.shareQrcodeList.splice(index, 1);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    handleQrcodeSuccess(res, index) {
      if (res.resultCode == 0) {
        this.shareForm.shareQrcodeList[index].qrcodeUrl = res.data.ylUrl;
        this.$forceUpdate();
      } else {
        this.$message.error(res.msg);
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG/PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    }
  }
};
</script>

<style scoped>
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both
}
</style>